import ICON_ARROW from "assets/images/icons/arrow/icon_arrow.svg";
import ICON_ARROW_ACTIVE_DOWN from "assets/images/icons/arrow/icon_arrow_active_down.svg";
import ICON_ARROW_ACTIVE_UP from "assets/images/icons/arrow/icon_arrow_active_up.svg";
import ICON_CLOSE_POPUP from "assets/images/icons/icon_close_popup.svg";
import LOGO_DABEEO from "assets/images/logos/logo_dabeeo.svg";
import ICON_FOV from "assets/images/icons/icon-fov.svg";
import ICON_DUCK from "assets/images/icons/rubber-duck.png";

export const ICON = {
  LOGO_DABEEO,

  ICON_ARROW,
  ICON_ARROW_ACTIVE_UP,
  ICON_ARROW_ACTIVE_DOWN,

  ICON_CLOSE_POPUP,
  ICON_FOV,
  ICON_DUCK,
};
